var map = {
	"./database.png": "a27e",
	"./domain.png": "6738",
	"./hosting.png": "8242",
	"./logo.jpg": "b640",
	"./mainbg.jpg": "a34e",
	"./mobile.png": "978f",
	"./network.png": "42e0",
	"./products/mirk-accounting.jpg": "17ca",
	"./products/mirka-accounting1.png": "f680",
	"./products/mirka-accounting2.png": "20a9",
	"./products/mirka-accounting3.png": "1cce",
	"./products/mirka-accounting4.png": "44c6",
	"./products/online-ordering.jpg": "0f6a",
	"./products/restaurant.jpg": "f410",
	"./products/travel-agency.jpg": "bf96",
	"./products/travel1.png": "3da1",
	"./products/travel2.png": "ac3f",
	"./products/travel3.png": "efb0",
	"./products/travel4.png": "b980",
	"./socialmedia.png": "0e04",
	"./web.png": "edbf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";